export const MAX_AGE_PROFILE_WEEKS_COUNT = 8

export const COMPLAINT_CLOSED_STATUSES = ["Complaint closed"]
export const COMPLAINT_OPEN_STATUSES = [
  "Complaint open",
  "Complaint reopened",
  "Ombudsman complaint",
]

export const COMPLAINT_DEFAULT_STATUS_FILTER_OPTIONS = {
  "Complaint open": "Complaint open",
  "Ombudsman complaint": "Ombudsman complaint",
  Other: "Other",
  "Complaint reopened": "Complaint reopened",
  "Complaint closed": "Complaint closed",
} as const

export const COMPLAINT_DEFAULT_TYPE_FILTER_OPTIONS = {
  Exec: "Exec",
  Inbound: "Inbound",
  OS: "OS",
  CAB: "CAB",
  PR: "PR",
  EHU: "EHU",
  Legal: "Legal",
  "Scot Advice": "Scot Advice",
} as const
